'use client';

import { SUPPORTED_CHAINS } from '@frontend/common';
import { defaultPublicRpc } from '@frontend/utils/env.client';
import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
  argentWallet,
  coinbaseWallet,
  ledgerWallet,
  phantomWallet,
  rabbyWallet,
  trustWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { cookieStorage, createStorage } from '@wagmi/core';
import { http } from 'viem';
import { Config } from 'wagmi';

export const generateWagmiConfig = (): Config => {
  const projectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID || '';

  const createTransports = () => {
    return Object.fromEntries(
      SUPPORTED_CHAINS.map((chain) => [
        chain.id,
        http(defaultPublicRpc(chain.id), { batch: true }),
      ]),
    );
  };

  const transports = createTransports();
  const { wallets } = getDefaultWallets();

  const myWallets = [
    ...wallets.map((wallet) => ({ ...wallet })),
    {
      groupName: 'Other',
      wallets: [
        phantomWallet,
        rabbyWallet,
        coinbaseWallet,
        argentWallet,
        trustWallet,
        ledgerWallet,
      ],
    },
  ];

  const wagmiConfig = getDefaultConfig({
    chains: SUPPORTED_CHAINS,
    transports,
    multiInjectedProviderDiscovery: true,
    projectId,
    appName: 'yodl',
    appDescription: 'yodl',
    appIcon: 'https://yodl.me/assets/images/favicon-96x96.png',
    appUrl: 'https://yodl.me',
    ssr: true,
    wallets: myWallets,
    storage: createStorage({
      storage: cookieStorage,
    }),
  });

  return wagmiConfig;
};
